import { render } from "./NfseRowActions.vue?vue&type=template&id=2db051fe&scoped=true"
import script from "./NfseRowActions.vue?vue&type=script&lang=js"
export * from "./NfseRowActions.vue?vue&type=script&lang=js"

import "./NfseRowActions.vue?vue&type=style&index=0&id=2db051fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db051fe"]])

export default __exports__